import * as React from 'react';

import styled from 'styled-components';
import { Drawer as MuiDrawer, Grid, useMediaQuery } from '@material-ui/core';

import Header from './header/header';
import Menu from './menu/menu';
import Footer from './footer';
import { useEffect, useState } from 'react';

export interface MainLayoutProps {
  children?: any;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const mediaQuery: boolean = useMediaQuery('(max-width:960px)'); //768px
  const [shouldCollapse, setShouldCollapse] = useState<boolean>(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(shouldCollapse);

  useEffect(() => {
    setShouldCollapse(Boolean(mediaQuery));
  }, [mediaQuery]);

  // Styles
  const DashboardContainer = styled.div`
    display: flex;
    height: 100%;
    overflow-x: hidden;
  `;
  const HeaderContainer = styled.div`
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    z-index: ${(props) => props.theme.zIndex.drawer + 1};
  `;
  const Sidebar = styled.div`
    //top: ${(props) => props.theme.spacing(2)}px;
    position: relative;
    transition: ${(props) =>
      props.theme.transitions.create(['width'], {
        easing: props.theme.transitions.easing.sharp,
        duration: props.theme.transitions.duration.leavingScreen,
      })};
    width: ${(props) => props.theme.menu.width}px;
    min-width: ${(props) => props.theme.menu.width}px;
    ${(props) => {
      if (isSidebarCollapsed || shouldCollapse) {
        return `width: ${props.theme.menu.widthCollapsed}px; min-width: ${props.theme.menu.widthCollapsed}px;`;
      }
    }};
    @media (max-width: 768px) {
      top: ${(props) => props.theme.spacing(2)}px;
      height: calc(100vh - ${(props) => props.theme.spacing(2)}px);
    }
  `;
  const Drawer = styled(MuiDrawer)`
    > .MuiDrawer-paper {
      width: 100%;
      position: absolute;
      ${() => {
        if (isSidebarCollapsed || shouldCollapse) {
          return `overflow-x: hidden;
          `;
        }
      }};
    }
  `;
  const Main = styled(Grid)`
    flex-grow: 1;
    height: calc(100vh - ${(props) => props.theme.spacing(8)}px);
    flex-direction: column;
    display: flex;
  `;
  const HeaderSpacer = styled.div`
    min-height: ${(props) => props.theme.spacing(8)}px;
  `;

  function handleSidebarToggle() {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  }

  return (
    <DashboardContainer>
      <HeaderContainer>
        <Header
          onToggle={handleSidebarToggle}
          isCollapsed={isSidebarCollapsed || shouldCollapse}
        />
      </HeaderContainer>
      <Sidebar>
        <Drawer variant='permanent' classes={{ paper: `menuPaper` }}>
          <Menu isCollapsed={isSidebarCollapsed || shouldCollapse} />
        </Drawer>
      </Sidebar>
      <Main item xs={12}>
        <HeaderSpacer />
        {children}
        <Footer />
      </Main>
    </DashboardContainer>
  );
}
